import React from 'react'
import PropTypes from 'prop-types'
import classes from 'classnames'

import { values, isBoolean } from 'lodash'


import { ui } from '../redux'

import FormGroup from '../components/FormGroup'


const Switch = (props) => {
    const {
        label, input, meta, intent, description, size, isHorizontal, ...otherProps
    } = props
    const { name } = input
    const { error } = meta

    return (
        <FormGroup
            name={ name }
            label={ label }
            error={ error }
            description={ description }
            isHorizontal={ isHorizontal }
        >
            <div
                className={ classes(
                    'switch-button',
                    `switch-button-${size}`,
                    `switch-button-${intent}`
                ) }
            >
                <input
                    id={ name }
                    checked={ isBoolean(input.value) && input.value }
                    type="checkbox"
                    { ...otherProps }
                    { ...input }
                />
                <span>
                    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                    <label htmlFor={ name } />
                </span>
            </div>
        </FormGroup>
    )
}

Switch.propTypes = {
    label        : PropTypes.string,
    input        : PropTypes.object,
    meta         : PropTypes.object,
    description  : PropTypes.string,
    size         : PropTypes.oneOf(values(ui.SIZE)),
    intent       : PropTypes.oneOf(values(ui.INTENT)),
    isHorizontal : PropTypes.bool
}

Switch.defaultProps = {
    size   : ui.SIZE.small,
    intent : ui.INTENT.primary
}

export default Switch
